import { RenderedDie } from "@/components/RenderedDie";
import { useRenderedDiceStore } from "@/hooks/useRenderedDiceStore";
import { Suspense } from "react";

export const RenderedDice = () => {
  const ids = useRenderedDiceStore((state) => state.renderedDice.ids);

  return ids.map((id: string) => (
    <Suspense key={`${id}-die`}>
      <RenderedDie id={id} />
    </Suspense>
  ));
};
